var doc = document;

export function setDocument(mockDoc) {
    doc = mockDoc;
}

/**
 * Reads and returns the value of a cookie given by its name.
 * @param {string} Name of the cookie to read.
 * @return {string} Value of the cookie, or undefined if the cookie is not set.
 */
export function read(str) {
    var cookies = doc.cookie ? doc.cookie.split('; ') : [],
        cookie,
        eqIndex,
        name,
        value,
        i;
    for (i = 0; i < cookies.length; i++) {
        cookie = cookies[i];
        eqIndex = cookie.indexOf('=');
        name = decodeURIComponent(cookie.substring(0, eqIndex));
        if (str === name) {
            value = cookie.substring(eqIndex + 1);
            value = decodeURIComponent(value.replace(/\+/g, ' ')); // replace pluses with spaces, then decode
            break;
        }
    }
    return value;
}


//////////////////
// WEBPACK FOOTER
// ./shared/modules/cookie.js
// module id = 81
// module chunks = main